import React, {useEffect, useState} from 'react'
import { CgArrowLeft } from 'react-icons/cg'
import icon1 from "../../../../../assets/jobIcons/icon1.svg"
import "react-quill/dist/quill.snow.css"
import axios from "axios"
import {Link, useParams} from "react-router-dom"
import "react-loading-skeleton/dist/skeleton.css"
import { formatDateTime, formatSalary } from '../../../../../../components/DateTimeConverter/DateTimeConverter'

const About = ({item}) => {
    const { id } = useParams(); // Récupérer l'id du job à partir de l'URL

  return (
    <div className=''>
        <div className=" flex justify-between  gap-10 text-sm">
      
       {/* Scrollable Content */}
       <div className="w-2/3 leading-loose text-justify text-black space-y-6">

       <div>
         <h4 className=" font-bold mb-2">
           Description
         </h4>
         <p className='text-primary-text'>
           {item?.description}
         </p>
       </div>

       <div>
         <h4 className=" font-bold mb-2">
           Compétences
         </h4>

         {item?.required_skills?.length > 0 ?
         <div className="flex flex-wrap gap-4">
            {item?.required_skills?.map((item, index)=>{
              <div key={index} className="font-[490] px-6 py-2 bg-gray-100 text-primary-text rounded-lg">
              {item?.name}
            </div>
            })}
            </div>
            :
            <p className='text-primary-text'>Non spécifié</p> 
            }
            
          
       </div>

       <div>
         <h4 className=" font-bold mb-2">
           Missions et Responsabilités
         </h4>
         <p className='text-primary-text'>
          {item?.mission}
          </p>
       </div>

       <div>
         <h4 className=" font-bold mb-2">
           Avantages
         </h4>
         <p className='text-primary-text'>
           {item?.benefits}
         </p>
       </div>


      </div>

      {/* Sticky Box */}
       <div className="w-1/3 h-fit   border border-gray-300 rounded-lg sticky top-20">
       <h5 className=' font-semibold py-4 text-start px-6'>Information générale</h5>
       <div className="border-b flex gap-4 items-center py-4 mx-6">
            <img src={icon1} alt="..." />
            <div className="flex justify-between flex-col text-start">
              <div className='text-sm text-primary-text'>Type d'offre</div>
              <div className='font-semibold'>{item?.contract_type}</div>
            </div>
          </div>  
          <div className="border-b flex gap-4 items-center py-4 mx-6">
            <img src={icon1} alt="..." />
            <div className="flex justify-between flex-col text-start">
              <div className='text-sm text-primary-text'>Mode de travail</div>
              <div className='font-semibold'>{item?.working_method}</div>
            </div>
          </div>  
           {/* Salaire */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <img src={icon1} alt="..." />
        <div className="flex justify-between flex-col text-start">
          <div className='text-sm text-primary-text'>Salaire</div>
          <div className='font-semibold'>{formatSalary(item?.salary)}</div>
        </div>
      </div>

      {/* Date de publication */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <img src={icon1} alt="..." />
        <div className="flex justify-between flex-col text-start">
          <div className='text-sm text-primary-text'>Date de publication</div>
          <div className='font-semibold'>{formatDateTime(item?.created_at)}</div>
        </div>
      </div>

      {/* Date d'expiration */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <img src={icon1} alt="..." />
        <div className="flex justify-between flex-col text-start">
          <div className='text-sm text-primary-text'>Date d'expiration</div>
          <div className='font-semibold'>{formatDateTime(item?.appli_end_at)}</div>
        </div>
      </div> 
           </div>
     </div>

    </div>
  )
}

export default About